<template>
    <div class="page">

        <wx-open-launch-weapp
            id="launch-btn"
            :username="miniProgram.username"
            @launch="onLaunchWeApp"
            @error="onLaunchWeAppError"
        >
            <script type="text/wxtag-template">
                <style>
                    .ant-btn {
                        line-height: 1.499;
                        position: relative;
                        display: inline-block;
                        font-weight: 400;
                        white-space: nowrap;
                        text-align: center;
                        background-image: none;
                        border: 1px solid #d9d9d9;
                        -webkit-box-shadow: 0 2px 0 rgba(0,0,0,0.015);
                        box-shadow: 0 2px 0 rgba(0,0,0,0.015);
                        cursor: pointer;
                        -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
                        transition: all .3s cubic-bezier(.645, .045, .355, 1);
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        -ms-touch-action: manipulation;
                        touch-action: manipulation;
                        height: 32px;
                        padding: 0 15px;
                        font-size: 14px;
                        border-radius: 4px;
                        color: rgba(0,0,0,0.65);
                        background-color: #fff;
                    }
                    .ant-btn-red {
                        color: #fff;
                        background-color: #FF5A44;
                        border-color: #FF5A44;
                        text-shadow: 0 -1px 0 rgba(0,0,0,0.12);
                        -webkit-box-shadow: 0 2px 0 rgba(0,0,0,0.045);
                        box-shadow: 0 2px 0 rgba(0,0,0,0.045);
                    }
                </style>
                <button class="ant-btn ant-btn-red">{{ miniProgram.btnText }}</button>
            </script>
        </wx-open-launch-weapp>

        <scrambleCourseModule ref="scrambleCourseModule1" title="资讯模块"
              desc="新闻列表布局" :itemCount="scrambleCourseModule1.itemCount"
            layout="verticalCardLayout"/>
        <div style="height: 20px"></div>

        <courseList2 ref="courseList2" title="课程列表"
              desc="纵向图文布局" :itemCount="courseList2.itemCount"
            layout="verticalImageTextLayout"/>
        <div style="height: 20px"></div>

    </div>
</template>

<script>
// modules
import scrambleCourseModule from '../index/scrambleCourseModule';

import courseList2 from '@pages/course/courseList2';
import consoleHelper from "@util/consoleHelper";

export default {
    name: "componentLibrary",
    components : {
        scrambleCourseModule, courseList2
    },
    data () {
        return {
            scrambleCourseModule1 : {
                itemCount : 3
            },
            courseList2 : {
                itemCount : 6
            },
            miniProgram : {
                username: 'gh_6c8280cec067', // gh_ 开头的原始小程序ID
                path: 'pages/index/index',
                btnText: '打开小程序',
            }
        }
    },
    methods : {
        onLaunchWeApp(e) {
            consoleHelper.log('success', e);
        },
        onLaunchWeAppError(e) {
            consoleHelper.log('fail', e.detail);
        }
    },
    mounted() {

    }
}
</script>
